import { render, staticRenderFns } from "./ConfirmDamage.vue?vue&type=template&id=9b16b022&scoped=true&"
import script from "./ConfirmDamage.vue?vue&type=script&lang=js&"
export * from "./ConfirmDamage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b16b022",
  null
  
)

export default component.exports